/* Govums CRO build - buy box, sticky bar, gallery, add to cart. No dependencies. */
(function () {
  'use strict';

  function money(cents) {
    var v = (cents / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + v.join('.');
  }

  /* ---------------------------------------------------------------------
     Cart traffic must not use this window's fetch or XMLHttpRequest.

     The Appstle Subscriptions bundle monkey-patches BOTH window.fetch and
     XMLHttpRequest.prototype.open/send at runtime. When its own widget has
     not mounted on the page, its /cart/add interceptor drops the
     selling_plan parameter, which silently converts a subscription into a
     full-price one-time order. Switching from fetch to XHR does not avoid
     this - both are patched.

     A freshly created about:blank iframe is same-origin and gets its own
     pristine JS realm, so its fetch/XMLHttpRequest are the untouched native
     implementations. We borrow those for cart requests. Relative URLs
     resolve against the parent document, and cookies/session are shared,
     so the request is identical in every respect except that it is not
     intercepted.

     Verified 16 Aug 2026 on the preview theme, same payload, same session:
       top-window fetch -> 5995, no selling plan
       top-window XHR   -> 5995, no selling plan
       pristine iframe  -> 5096, "Reorder Every 30 Days"

     If the iframe cannot be created for any reason we fall back to this
     window's XMLHttpRequest so the buy button still works; a one-time
     purchase is unaffected by the interceptor.
  --------------------------------------------------------------------- */
  var _net = null;
  function net() {
    if (_net) return _net;
    try {
      var f = document.createElement('iframe');
      f.setAttribute('aria-hidden', 'true');
      f.setAttribute('tabindex', '-1');
      f.style.cssText = 'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none';
      f.src = 'about:blank';
      (document.body || document.documentElement).appendChild(f);
      var w = f.contentWindow;
      /* Keep the iframe attached for the page lifetime - detaching it would
         invalidate the borrowed function references. */
      if (w && typeof w.XMLHttpRequest === 'function') {
        _net = { XHR: w.XMLHttpRequest, pristine: true };
        return _net;
      }
    } catch (e) {}
    _net = { XHR: window.XMLHttpRequest, pristine: false };
    return _net;
  }

  function request(method, url, body, contentType, accept) {
    var n = net();
    return new Promise(function (resolve, reject) {
      var x = new n.XHR();
      x.open(method, url, true);
      if (contentType) x.setRequestHeader('Content-Type', contentType);
      x.setRequestHeader('Accept', accept || 'application/json');
      x.onload = function () { resolve({ status: x.status, ok: x.status >= 200 && x.status < 300, text: x.responseText }); };
      x.onerror = function () { reject(new Error('Network error')); };
      x.send(body === undefined ? null : body);
    });
  }
  function requestJSON(method, url, body, contentType) {
    return request(method, url, body, contentType).then(function (r) {
      var j = null;
      try { j = JSON.parse(r.text); } catch (e) {}
      return { ok: r.ok, status: r.status, json: j };
    });
  }
  function getCart() {
    return requestJSON('GET', '/cart.js').then(function (r) { return r.json || { items: [], item_count: 0, total_price: 0 }; });
  }

  var addListeners = [];
  function onCartAdd(fn) { addListeners.push(fn); }
  function fireCartAdd() { for (var i = 0; i < addListeners.length; i++) { try { addListeners[i](); } catch (e) {} } }
  (function patchFetch() {
    if (!window.fetch || window.__croFetchPatched) return;
    window.__croFetchPatched = true;
    var orig = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var p = orig.apply(this, arguments);
      if (url && url.indexOf('/cart/add') !== -1 && !window.__croOwnsAdd) {
        p.then(function (r) { if (r && r.ok) setTimeout(fireCartAdd, 120); }).catch(function () {});
      }
      return p;
    };
  })();

  /* ---------------------------------------------------------------------
     Section Rendering API.

     The Accept header here must NOT be application/json. On a product URL
     Shopify answers an application/json request with the *product* resource
     and ignores ?sections= entirely, so j[id] is undefined, this function
     returned without doing anything, and the cart drawer kept the empty
     server-rendered markup it was built with at page load - the drawer then
     opened saying "Your cart is empty" even though /cart/add.js had just
     succeeded.

     Verified 19 Aug 2026 on the live theme, same URL, same session:
       Accept: application/json -> {"product":{...}}      4,846 bytes
       Accept: text/html        -> {"<section id>":"..."} 48,132 bytes
  --------------------------------------------------------------------- */
  function cartSectionEl() {
    var cd = document.querySelector('cart-drawer-component');
    return cd ? cd.closest('.shopify-section') : null;
  }

  function refreshCartSections() {
    var sec = cartSectionEl();
    if (!sec || !sec.id) return Promise.resolve();
    var id = sec.id.replace('shopify-section-', '');
    return request('GET', window.location.pathname + '?sections=' + encodeURIComponent(id), undefined, null, 'text/html')
      .then(function (r) {
        var j = null;
        try { j = JSON.parse(r.text); } catch (e) { return; }
        var html = j && j[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(sec.id) || doc.body.firstElementChild;
        if (fresh) sec.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* True only when the drawer is showing its empty state and contains no
     line items. Used for a single bounded re-render - never a polling loop. */
  function drawerLooksEmpty() {
    var cd = document.querySelector('cart-drawer-component');
    var dlg = cd ? cd.querySelector('dialog') : null;
    if (!dlg) return false;
    if (dlg.querySelector('.cart-item, [class*="cart-item"]')) return false;
    return /cart is empty/i.test(dlg.textContent || '');
  }

  /* If the drawer still reads empty but the cart is not, re-render once.
     A genuinely empty cart is left alone so the real empty state can show. */
  function ensureDrawerFresh() {
    if (!drawerLooksEmpty()) return Promise.resolve();
    return getCart().then(function (c) {
      if (!c || !c.item_count) return;
      return refreshCartSections();
    });
  }

  function initGallery(root) {
    var track = root.querySelector('[data-cro-gal-track]');
    var dots = root.querySelectorAll('[data-cro-gal-dot]');
    if (!track || !dots.length) return;
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        for (var d = 0; d < dots.length; d++) {
          if (d === i) { dots[d].setAttribute('data-on', ''); } else { dots[d].removeAttribute('data-on'); }
        }
        ticking = false;
      });
    }, { passive: true });
  }

  function cartHasPlan(cart) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].selling_plan_allocation) return true; }
    return false;
  }

  function confirmAdded(root, sticky, expectedPlan) {
    var live = root.querySelector('[data-cro-live]');
    var lbl = root.querySelector('[data-cro-cta-label]');
    var btn = root.querySelector('.cro-buy__cta button[name="add"]');
    if (lbl) {
      if (lbl.getAttribute('data-cro-original') === null) lbl.setAttribute('data-cro-original', lbl.textContent);
      lbl.textContent = 'Added to cart';
      if (btn) btn.style.background = '#155A3B';
      setTimeout(function () {
        lbl.textContent = lbl.getAttribute('data-cro-original');
        if (btn) btn.style.background = '';
      }, 2200);
    }
    if (sticky) {
      sticky.setAttribute('data-show', '');
      sticky.setAttribute('data-added', '');
      var meta = sticky.querySelector('.cro-sticky__meta');
      var sBtn = sticky.querySelector('[data-cro-sticky-btn]');
      if (meta) {
        meta.innerHTML = '<span class="cro-sticky__price">In your cart</span><span class="cro-sticky__unit" data-cro-cartline></span>';
      }
      if (sBtn) { sBtn.textContent = 'Checkout'; sBtn.setAttribute('data-cro-checkout', ''); }
    }
    getCart().then(function (c) {
      var isSub = cartHasPlan(c);
      if (sticky) {
        var line = sticky.querySelector('[data-cro-cartline]');
        if (line) line.textContent = c.item_count + (c.item_count === 1 ? ' item' : ' items') + (isSub ? ' · subscription' : '') + ' · ' + money(c.total_price);
      }
      if (live) live.textContent = 'Added to cart. ' + c.item_count + ' items, ' + money(c.total_price) + (isSub ? ', subscription' : '') + '.';
      if (expectedPlan && !isSub && window.console) {
        console.warn('[cro] selling_plan ' + expectedPlan + ' was requested but the cart line has no selling_plan_allocation.');
      }
    });
    var cd = document.querySelector('cart-drawer-component');
    if (cd && cd.hasAttribute('auto-open') && typeof cd.showDialog === 'function') {
      var dlg = cd.querySelector('dialog');
      if (!dlg || !dlg.open) { try { cd.showDialog(); } catch (e) {} }
    }
  }

  function ownSubmit(root, form, sticky) {
    window.__croOwnsAdd = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[name="add"]');
      var live = root.querySelector('[data-cro-live]');
      var planIn = form.querySelector('input[name="selling_plan"]:checked');
      var expectedPlan = planIn && planIn.value ? planIn.value : null;
      if (btn) btn.disabled = true;

      /* Serialise to urlencoded rather than posting FormData: the borrowed
         iframe realm has its own FormData constructor, and a urlencoded body
         is unambiguous across realms. */
      var params = new URLSearchParams();
      var fd = new FormData(form);
      fd.forEach(function (val, key) {
        if (key === 'selling_plan' && !expectedPlan) return; /* never send an empty plan */
        if (typeof val === 'string') params.append(key, val);
      });

      requestJSON('POST', '/cart/add.js', params.toString(), 'application/x-www-form-urlencoded')
        .then(function (r) {
          if (!r.ok) throw new Error((r.json && (r.json.description || r.json.message)) || 'Could not add to cart');
          return refreshCartSections();
        })
        .then(function () { return ensureDrawerFresh(); })
        .then(function () { confirmAdded(root, sticky, expectedPlan); })
        .catch(function (err) {
          if (live) live.textContent = err.message;
          var lbl = root.querySelector('[data-cro-cta-label]');
          if (lbl) {
            var was = lbl.textContent;
            lbl.textContent = 'Something went wrong';
            setTimeout(function () { lbl.textContent = was; }, 2600);
          }
        })
        .then(function () { if (btn) btn.disabled = false; });
    });
  }

  /* If Appstle ever does mount its own widget, keep our price display in sync. */
  function watchAppstle(root, render) {
    var mount = root.querySelector('#appstle_subscription_widget0');
    if (!mount) return;
    var mo = new MutationObserver(function () { render(); });
    mo.observe(mount, { childList: true, subtree: true, attributes: true });
    mount.addEventListener('change', render);
    mount.addEventListener('click', function () { setTimeout(render, 60); });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  function initBuy(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var priceEl = root.querySelector('[data-cro-price]');
    var unitEl = root.querySelector('[data-cro-unit]');
    var wasEl = root.querySelector('[data-cro-was]');
    var ctaPrice = root.querySelector('[data-cro-cta-price]');
    var qtyIn = root.querySelector('[data-cro-qty-input]');
    var minus = root.querySelector('[data-cro-qty-minus]');
    var plus = root.querySelector('[data-cro-qty-plus]');
    var sticky = document.querySelector('[data-cro-sticky]');
    var sPrice = sticky ? sticky.querySelector('[data-cro-sticky-price]') : null;
    var sUnit = sticky ? sticky.querySelector('[data-cro-sticky-unit]') : null;
    var sWas = sticky ? sticky.querySelector('[data-cro-sticky-was]') : null;
    var base = parseInt(root.getAttribute('data-base-price') || '0', 10);
    var servings = parseInt(root.getAttribute('data-servings') || '0', 10);

    /* ------------------------------------------------------------------
       Labor Day 2026 promotional pricing.

       data-promo-pct / data-promo-end are written by snippets/cro-promo.liquid
       and only ever appear on the eligible product. The percentage is applied
       to whichever option is selected - the one-time price, or a subscription's
       per-delivery price - which is exactly how the Shopify automatic discount
       prices the cart, so the buy box and checkout agree.

       Rounding matches Shopify exactly: the discount is computed per unit and
       FLOORED to the cent, then subtracted. On $59.95 that is floor(1498.75) =
       $14.98 and the price is $44.97 - a naive round-to-nearest gives $44.96
       and would under-quote the cart by a cent. Verified in a live cart on
       25 Aug 2026: qty 1 -> 4497, qty 2 -> 8994, so per-unit is also correct.

       Expiry is re-tested on every render against the SERVER clock captured by
       cro-promo.js (window.__croSkew), so a tab left open across the deadline
       re-prices itself instead of advertising a discount checkout will refuse.
       The variant's own price is never touched; base stays $59.95 throughout.
    ------------------------------------------------------------------ */
    var promoPct = parseInt(root.getAttribute('data-promo-pct') || '0', 10) || 0;
    var promoEnd = parseInt(root.getAttribute('data-promo-end') || '0', 10) || 0;

    function promoLive() {
      if (!promoPct || !promoEnd) return false;
      if (!root.hasAttribute('data-promo-pct')) return false; /* cleared on expiry */
      return (Math.floor(Date.now() / 1000) + (window.__croSkew || 0)) < promoEnd;
    }
    function promoize(cents) {
      if (!promoLive()) return cents;
      return cents - Math.floor((cents * promoPct) / 100);
    }

    /* Price of the currently selected plan, in cents. Prefers the value Liquid
       rendered on the radio (per_delivery_price); falls back to Appstle's DOM. */
    function selectedPlanPrice() {
      var r = form.querySelector('input[name="selling_plan"]:checked');
      if (!r) return null;
      var own = r.getAttribute('data-plan-price');
      if (own !== null && own !== '') {
        var n = parseInt(own, 10);
        if (!isNaN(n)) return n;
      }
      if (!r.value) return null;
      var wrap = r.closest('.appstle_subscription_wrapper_option') || form;
      var amt = wrap.querySelector('.appstle_subscription_amount');
      if (amt) {
        var m = (amt.textContent || '').replace(/[^0-9.]/g, '');
        if (m) return Math.round(parseFloat(m) * 100);
      }
      return null;
    }

    function render() {
      if (sticky && sticky.hasAttribute('data-added')) return;
      /* list = the undiscounted price of the selected option. */
      var list = selectedPlanPrice();
      if (list === null) list = base;
      var each = promoize(list);
      var qty = qtyIn ? Math.max(1, parseInt(qtyIn.value || '1', 10) || 1) : 1;
      var total = each * qty;
      /* The struck figure is always the regular one-time price, so the saving
         reads against $59.95 whether the shopper is buying once or subscribing. */
      var wasTotal = base * qty;
      if (priceEl) priceEl.textContent = money(total);
      if (wasEl) {
        if (total < wasTotal) { wasEl.textContent = money(wasTotal); wasEl.hidden = false; } else { wasEl.hidden = true; }
      }
      if (sWas) {
        if (total < wasTotal) { sWas.textContent = money(wasTotal); sWas.hidden = false; } else { sWas.hidden = true; }
      }
      if (unitEl && servings > 0) unitEl.textContent = money(Math.round(each / servings)) + ' per serving';
      if (ctaPrice) ctaPrice.textContent = money(total);
      if (sPrice) sPrice.textContent = money(total);
      if (sUnit && servings > 0) sUnit.textContent = money(Math.round(each / servings)) + ' per serving' + (qty > 1 ? ' ×' + qty : '');
    }

    form.addEventListener('change', render);
    form.addEventListener('input', render);
    watchAppstle(root, render);
    /* cro-promo.js fires this the moment the sale window closes in-session. */
    document.addEventListener('cro:promo-expired', render);

    function step(n) {
      if (!qtyIn) return;
      var v = Math.max(1, Math.min(99, (parseInt(qtyIn.value || '1', 10) || 1) + n));
      qtyIn.value = v;
      if (minus) minus.disabled = v <= 1;
      render();
    }
    if (minus) minus.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
    if (plus) plus.addEventListener('click', function (e) { e.preventDefault(); step(1); });
    if (minus && qtyIn) minus.disabled = (parseInt(qtyIn.value || '1', 10) || 1) <= 1;

    render();

    if (root.hasAttribute('data-cro-pdp')) { ownSubmit(root, form, sticky); }
    else { onCartAdd(function () { confirmAdded(root, sticky, null); }); }

    var anchor = root.querySelector('[data-cro-cta-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var ctaOut = false, footerIn = false;
      var apply = function () {
        if (sticky.hasAttribute('data-added')) { sticky.setAttribute('data-show', ''); return; }
        if (ctaOut && !footerIn) { sticky.setAttribute('data-show', ''); } else { sticky.removeAttribute('data-show'); }
      };
      new IntersectionObserver(function (es) { ctaOut = !es[0].isIntersecting; apply(); }, { rootMargin: '0px 0px -40px 0px' }).observe(anchor);
      var foot = document.querySelector('footer');
      if (foot) new IntersectionObserver(function (es) { footerIn = es[0].isIntersecting; apply(); }).observe(foot);
    }

    var sBtn = sticky ? sticky.querySelector('[data-cro-sticky-btn]') : null;
    if (sBtn) {
      sBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (sBtn.hasAttribute('data-cro-checkout')) { window.location.href = '/checkout'; return; }
        var real = root.querySelector('.cro-buy__cta button[name="add"]');
        if (real && !real.disabled) real.click();
      });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-cro-pdp], [data-cro-homebuy]');
    for (var i = 0; i < roots.length; i++) { initGallery(roots[i]); initBuy(roots[i]); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();
